import * as React from "react";
type Props = {
  className?: string,
};
function SvgXCircle({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-x-circle"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM16.5 8.85437L15.1456 7.5C15.1456 7.5 13.6602 8.98544 12 10.6511C10.3398 8.98544 8.85437 7.5 8.85437 7.5L8.00243 8.35194L7.5 8.85437C7.5 8.85437 8.98544 10.3398 10.6511 12C8.98544 13.6602 7.5 15.1456 7.5 15.1456L8.85437 16.5C8.85437 16.5 10.3398 15.0146 12 13.3489C13.6602 15.0146 15.1456 16.5 15.1456 16.5L16.5 15.1456C16.5 15.1456 15.0146 13.6602 13.3489 12C15.0146 10.3398 16.5 8.85437 16.5 8.85437Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgXCircle;
